import React from 'react'
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../Setup/Shared/ModalHeader';

const DiscardChangesPopup = (props) => {
    const { isDiscardChanges, handleCancelDiscard, onProceedWithDiscardChanges } = { ...props }

    const select = () => {
        return <p className='heading Rejected_clr'>Discard Changes</p>;
    };
    return (
        <Modal show={isDiscardChanges} onHide={handleCancelDiscard} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
            <ModalHeader HeaderName={select} DeletePopup={""} isClosed={handleCancelDiscard} key={111} Name={'DiscardChangesPopup'} />
            <Modal.Body>
                <div className='ar-alert d-flex mb-12'>
                    <i className='icon-alert mt-1'></i>
                    <div>
                        <p className='text ms-1'>You have unsaved changes.Are you sure you want to discard them?</p>
                    </div>
                </div>
            </Modal.Body>

            <div className="modal_footer za_br_light br-top-1 pt-2 ">
                <div className='za-button text-end d-flex justify-content-end gap-2'>
                    <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={handleCancelDiscard}>Keep Editing</button>
                    <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => onProceedWithDiscardChanges()}>Discard Changes</button>
                </div>
            </div>
        </Modal>
    )
}

export default DiscardChangesPopup